module.exports = {"350111001":"茶园街道","350111002":"王庄街道","350111003":"象园街道","350111100":"鼓山镇","350111101":"新店镇","350111102":"岳峰镇","350111103":"宦溪镇","350111201":"寿山乡","350111202":"日溪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350111.json
// module id = 1069
// module chunks = 0